import { render, staticRenderFns } from "./ItinerarySectionItemDetails.vue?vue&type=template&id=2d82a206&scoped=true&"
import script from "./ItinerarySectionItemDetails.vue?vue&type=script&lang=js&"
export * from "./ItinerarySectionItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./ItinerarySectionItemDetails.vue?vue&type=style&index=0&id=2d82a206&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d82a206",
  null
  
)

export default component.exports